// extracted by mini-css-extract-plugin
module.exports = {"smart-tv":"mobile-apps_smart-tv__ChUUJ","android":"mobile-apps_android__W819u","apple":"mobile-apps_apple__WJUoT"};